import React, { Component } from 'react'
import { isWebIos } from '../../../../utils/ut.web';
import { sendClickDataWithJsonParam } from '../../../../components/utiles'

import play from '../../../../images/detail/play.png'
const isIOS = isWebIos();
export default class VideoPlayerWeb extends Component{
    constructor(props) {
        super(props);
        this.state = {
            playStatus : 'pause', // play pause
            // 第一次进入页面时不展示加载条
            controlStatus: true,
            muted:false, // 视频默认未静音播放
        }
    }
    // 改变播放状态
    changePalyStatus = () => {
        const {playStatus} = this.state;
        if(this.videoRef){
            if(playStatus === 'play'){
                this.videoRef.pause();
            }else{
                this.videoRef.play();
            }
        }
    }
    // 播放
    onPlay = () => {
        const { playUrl, pageId, skuId } = this.props;
		sendClickDataWithJsonParam({
			event_id: 'OfficeBuilding_HouseDetail_Video',
			page_id: pageId,
			json_param: {
				skuid: skuId,
                video_url: playUrl
			},
		})
        this.setState({playStatus: 'play',controlStatus: true});
    }
    // 暂停
    onPause = () => {
        this.setState({playStatus: 'pause',controlStatus: true})
    }
    // 外部使用播放方法
    outControlPlay = () => {
        this.videoRef && this.videoRef.play();
    }
    // 外部使用暂停方法
    outControlPause = () => {
        this.videoRef && this.videoRef.pause();
    }
    changeVolumnStatus = () => {
        if(this.state.muted){
            this.videoRef.muted = false;
            this.setState({muted: false})
        }else{
            this.videoRef.muted = true;
            this.setState({muted: true})
        }
      
    }
    componentDidMount(){
        this.setState({controlStatus: false});

    }
    render(){
        const {playStatus,controlStatus} = this.state;
        const {surfacePlot,playUrl} = this.props;
        return (
            <div className='player'>
                <video  
                    preload="auto" 
                    width='100%'  
                    height='100%'  
                    controls={!isIOS}
                    className={["video",!controlStatus && "androidHiddenControl"].join(' ')}
                    disablePictureInPicture
                    controlsList="nodownload noplaybackrate"
                    x5-video-player-type="h5" x5-video-player-fullscreen="true"
                    // webkit-playsinline="true" playsInline="true"
                    // x-webkit-airplay="true"
                    ref={(video) => {this.videoRef = video}}
                    onPlaying={this.onPlay}
                    onPause={this.onPause}
                    poster={surfacePlot}
                >
                    <source src={ playUrl } type='video/mp4' />
                </video>
                {
                     <div className={[`video-mask`,playStatus == 'play' ?'video_mask_hidden':'video_mask_show',isIOS && 'mask_full_screen'].join(' ')} onClick={this.changePalyStatus}>
                    {/* ios中使用封面图占位轮播，防止出现ios小屏默认视频按钮功能 */}
                    {
                        isIOS && <img src={surfacePlot} className='ios_video_surface_plot' />
                    }
                    <div className="conbtn">
                        {
                            isIOS && playStatus === 'pause' && <img src={play} alt="play" className='conbtn_img' />
                        }
                        {/* {
                            playStatus === 'play' && <img src={pause} alt="pause" className='conbtn_img' />
                        } */}
                    </div>
                </div>
                }
            </div>
        )
    }
}